import _ from 'lodash';

const defaultState = {
  dashboard: null,
  health: null,
  impact: null,
  ownerFilter: null,
  loading: {},
  error: null,
};

const consultantDashboardReducers = (state, action) => {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case 'CONSULTANT_DASHBOARD_SET':
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        dashboard: action.payload || null,
        error: null,
      };
      return newState;

    case 'CONSULTANT_DASHBOARD_HEALTH':
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        health: action.payload || null,
        error: null,
      };
      return newState;

    case 'CONSULTANT_DASHBOARD_IMPACT':
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        impact: action.payload || null,
        error: null,
      };
      return newState;

    case 'CONSULTANT_DASHBOARD_OWNER_FILTER':
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        ownerFilter: action.payload || null,
      };
      return newState;

    case 'CONSULTANT_DASHBOARD_LOADING': {
      const loading = { ...(newState.consultantDashboard?.loading || {}) };
      if (action.value) loading[action.key] = true;
      else delete loading[action.key];
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        loading,
      };
      return newState;
    }

    case 'CONSULTANT_DASHBOARD_ERROR':
      newState.consultantDashboard = {
        ...(newState.consultantDashboard || defaultState),
        error: action.error || null,
      };
      return newState;

    default:
      return state;
  }
};

export default consultantDashboardReducers;
export { defaultState as consultantDashboardDefaultState };
